(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-clients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ac-customer-reviews')) {
    customElements.define('ac-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.grid = this.querySelector('[data-grid]');
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.sort = this.querySelector('[data-sort]');
        this.more = this.querySelector('[data-more]');
        this.status = this.querySelector('[data-status]');
        this.dots = this.querySelector('[data-dots]');
        this.editor = this.dataset.editor === 'true';
        this.media = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.step = Math.max(1, Number(this.dataset.initial) || 3);
        this.limit = this.editor ? this.cards.length : this.step;
        this.active = 0;
        this.frame = null;
        const formatter = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
        for (const card of this.cards) {
          const raw = card.dataset.date;
          const date = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? new Date(raw + 'T12:00:00Z') : null;
          card.acTimestamp = date && !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === raw ? date.getTime() : 0;
          const time = card.querySelector('[data-review-date]');
          if (time && card.acTimestamp) time.textContent = formatter.format(date);
          else if (time) time.hidden = true;
        }
        this.buildDots();
        this.querySelector('.ac-reviews__sorting').hidden = this.cards.length < 2 || this.editor;
        this.sort.addEventListener('change', () => {
          this.limit = this.step;
          this.active = 0;
          this.reorder();
          this.render();
          if (this.media.matches) this.goTo(0, false);
        }, options);
        this.more.addEventListener('click', () => {
          const firstNew = this.cards[this.limit];
          this.limit += this.step;
          this.render();
          if (firstNew) {
            firstNew.tabIndex = -1;
            firstNew.focus({ preventScroll: true });
          }
        }, options);
        this.dots.addEventListener('click', event => {
          const dot = event.target.closest('[data-dot]');
          if (dot && this.dots.contains(dot)) this.goTo(Number(dot.dataset.dot));
        }, options);
        this.dots.addEventListener('keydown', event => {
          const dot = event.target.closest('[data-dot]');
          if (!dot) return;
          let index = Number(dot.dataset.dot);
          if (event.key === 'ArrowRight') index++;
          else if (event.key === 'ArrowLeft') index--;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.cards.length - 1;
          else return;
          event.preventDefault();
          index = Math.max(0, Math.min(index, this.cards.length - 1));
          this.dotButtons[index]?.focus({ preventScroll: true });
          this.goTo(index);
        }, options);
        this.grid.addEventListener('scroll', () => {
          if (!this.media.matches || this.frame !== null) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.syncActive();
          });
        }, { ...options, passive: true });
        this.media.addEventListener('change', () => {
          this.render(false);
          if (this.media.matches) this.goTo(this.active, false);
          else this.grid.scrollTo({ left: 0, behavior: 'instant' });
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          if (this.media.matches) this.goTo(this.active, false);
        });
        this.resizeObserver.observe(this.grid);
        document.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(item => item.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.limit = this.cards.length;
          this.render(false);
          if (this.media.matches) this.goTo(index, false);
          this.cards[index].scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'instant' });
        }, options);
        this.render(false);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.controller = null;
      }
      buildDots() {
        this.dotButtons = this.cards.map((card, index) => {
          if (!card.id) card.id = this.id + '-card-' + card.dataset.blockId;
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ac-reviews__dot';
          dot.dataset.dot = index;
          dot.setAttribute('aria-label', this.dots.dataset.dotLabel.replace('[index]', index + 1).replace('[total]', this.cards.length));
          dot.setAttribute('aria-controls', card.id);
          dot.setAttribute('aria-current', 'false');
          return dot;
        });
        this.dots.replaceChildren(...this.dotButtons);
      }
      reorder() {
        const mode = this.sort.value;
        this.cards.sort((a, b) => {
          const tie = Number(a.dataset.order) - Number(b.dataset.order);
          if (mode === 'recent') return b.acTimestamp - a.acTimestamp || tie;
          if (mode === 'best') return Number(b.dataset.rating) - Number(a.dataset.rating) || tie;
          if (mode === 'worst') return Number(a.dataset.rating) - Number(b.dataset.rating) || tie;
          return tie;
        });
        this.cards.forEach(card => this.grid.append(card));
        this.buildDots();
      }
      goTo(index, smooth = true) {
        if (!this.media.matches || !this.cards.length) return;
        index = Math.max(0, Math.min(index, this.cards.length - 1));
        const card = this.cards[index];
        const left = card.getBoundingClientRect().left - this.grid.getBoundingClientRect().left + this.grid.scrollLeft;
        this.grid.scrollTo({ left, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant' });
        this.active = index;
        this.updateDots();
      }
      syncActive() {
        const left = this.grid.getBoundingClientRect().left;
        let closest = Infinity;
        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left);
          if (distance < closest) { closest = distance; this.active = index; }
        });
        this.updateDots();
      }
      updateDots() {
        this.dotButtons.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.active)));
      }
      render(announce = true) {
        const allVisible = this.media.matches || this.editor;
        this.cards.forEach((card, index) => { card.hidden = !allVisible && index >= this.limit; });
        this.more.hidden = allVisible || this.limit >= this.cards.length;
        this.dots.hidden = !this.media.matches || this.cards.length < 2;
        this.updateDots();
        if (announce) {
          const count = allVisible ? this.cards.length : Math.min(this.limit, this.cards.length);
          this.status.textContent = this.status.dataset.pattern.replace('[count]', count).replace('[total]', this.cards.length);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-customer-reviews')) {
    customElements.define('ct-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.grid = this.querySelector('[data-grid]');
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.sort = this.querySelector('[data-sort]');
        this.sort.value = this.dataset.defaultSort || 'manual';
        this.more = this.querySelector('[data-more]');
        this.status = this.querySelector('[data-status]');
        this.editor = this.dataset.editor === 'true';
        this.step = Math.max(1, Number(this.dataset.initial) || 3);
        this.limit = this.editor ? this.cards.length : this.step;
        const formatter = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
        for (const card of this.cards) {
          const raw = card.dataset.date;
          const date = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? new Date(raw + 'T12:00:00Z') : null;
          card.acTimestamp = date && !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === raw ? date.getTime() : 0;
          const time = card.querySelector('[data-review-date]');
          if (time && card.acTimestamp) time.textContent = formatter.format(date);
          else if (time) time.hidden = true;
        }
        this.querySelector('.ct-reviews__sorting').hidden = this.cards.length < 2 || this.editor;
        this.sort.addEventListener('change', () => {
          this.limit = this.step;
          this.reorder();
          this.render();
        }, options);
        this.more.addEventListener('click', () => {
          const firstNew = this.cards[this.limit];
          this.limit += this.step;
          this.render();
          if (firstNew) {
            firstNew.tabIndex = -1;
            firstNew.focus({ preventScroll: true });
          }
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (!card) return;
          this.limit = this.cards.length;
          this.render(false);
          card.scrollIntoView({ block: 'center', behavior: 'auto' });
        }, options);
        if (!this.editor) this.reorder();
        this.render(false);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      reorder() {
        const mode = this.sort.value;
        this.cards.sort((a, b) => {
          const tie = Number(a.dataset.order) - Number(b.dataset.order);
          if (mode === 'recent') return b.acTimestamp - a.acTimestamp || tie;
          if (mode === 'best') return Number(b.dataset.rating) - Number(a.dataset.rating) || tie;
          if (mode === 'worst') return Number(a.dataset.rating) - Number(b.dataset.rating) || tie;
          return tie;
        });
        this.cards.forEach(card => this.grid.append(card));
      }
      render(announce = true) {
        this.cards.forEach((card, index) => { card.hidden = index >= this.limit; });
        this.more.hidden = this.limit >= this.cards.length;
        if (announce) this.status.textContent = this.status.dataset.pattern.replace('[count]', Math.min(this.limit, this.cards.length)).replace('[total]', this.cards.length);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
